'use client'

// imports
import { useAtom } from 'jotai';

// lib files
import { ORIGIN_STRING } from "@/lib/constants";
import { clearLocalProfile } from "@/lib/helpers/handle-sign-out";
import { passportTransferMembershipAtom } from "@/lib/atoms/passport-transfer";
import { setRedirectCookie } from "@/lib/helpers/utils";
import { useHasMounted } from "@/lib/hooks";
import { isEmpty } from '@/lib/helpers/empty';

// components
import LinkButton from '@/components/Button/LinkButton';
import PassportTransferFAQ from '@/components/passport/PassportTransferFAQ/PassportTransferFAQ';

// constants
import { PASSPORT_TRANSFER_ONE_MEMBERSHIP } from '@/components/passport/PassportTransferFAQ/PassportTransferFAQContent';

// styles
import styles from './PassportTransferOneMembership.module.scss';

// types
import { PassportTransferMembership } from "@/lib/types/passportTransferMembership";

interface PassportTransferOneMembershipProps {
  membership: PassportTransferMembership;
  email: string;
}

export default function PassportTransferOneMembership(props: PassportTransferOneMembershipProps) {
  const { membership, email } = props;
  const [ _, setPassportTransferMembership ] = useAtom(passportTransferMembershipAtom);
  const hasMounted = useHasMounted();

  if (!hasMounted) {
    return null;
  }

  const membershipWithEmail = { ...membership, membership_transfer_from_email: email };

  const hostname = isEmpty(ORIGIN_STRING) ? `https://${window.location.host}` : ORIGIN_STRING

  const passportTransferSignIntoNewAccountURL = `${hostname}/passport/transfer/sign-into-new-account/`;
  const passportTransferActivateMembershipUrl = `${hostname}/passport/transfer/activate-membership/`;
  const shortCommonName = membership.station_data?.attributes.short_common_name;

  return (
    <div className={styles.passport_transfer_one_membership}>
      <h1>Transfer Your {shortCommonName} Passport Benefit to a Different Email</h1>
      <p className={styles.passport_transfer_one_membership__description}>
        You will use this login to access Passport shows and films moving forward.
      </p>
      <div className={styles.passport_transfer_one_membership__buttons}>
        <LinkButton
          href={`${ORIGIN_STRING}/sso/logout?redirect=${passportTransferSignIntoNewAccountURL}`}
          style='white' wrapperComponent='a'
          onClick={() => {
            setPassportTransferMembership(membershipWithEmail)
            clearLocalProfile()
          }}
        >
          Sign In
        </LinkButton>
        <LinkButton
          href={`${ORIGIN_STRING}/sso/logout?redirect=${hostname}/sso/register?activation=true`}
          style='blue'
          onClick={() => {
            setPassportTransferMembership(membershipWithEmail)
            setRedirectCookie(passportTransferActivateMembershipUrl)
            clearLocalProfile()
          }}
          wrapperComponent='a'
        >
          Create an Account
        </LinkButton>
      </div>
      <PassportTransferFAQ faqBank={PASSPORT_TRANSFER_ONE_MEMBERSHIP} />
    </div>
  )
}
